import { Fragment, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';
import ButtonGroup from '@mui/material/ButtonGroup';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import CheckIcon from '@mui/icons-material/Check';
import { PageFilter } from '../../model/page';


interface SavedViewProps {
    label?: string;
    views?: PageFilter[];
}


export default function ViewDropDownMenu({ label, views }: SavedViewProps) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);
    const [selectedIndex] = useState(0);
    // const [selectedOption, setSelectedOption] = useState<PageFilter | undefined>(undefined);

    const handleMenuItemClick = (
        event: React.ChangeEvent<HTMLInputElement>,
        index: number,
    ) => {
        console.log('handle menu item click');
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (
            anchorRef.current
        ) {
            return;
        }

        setOpen(false);
    };



    return (
        <Fragment>
            <ButtonGroup color="info" disableElevation={true} variant="text" ref={anchorRef}
                sx={{
                    [`.MuiButtonGroup-grouped:not(:last-of-type)`]: {
                        borderColor: 'action.active',
                        minWidth: '140px'
                    },
                }}
            >
                <Button
                    color="secondary"
                    onClick={handleToggle}
                    sx={{
                        fontSize: '16px',
                        justifyContent: 'center',
                        backgroundColor: 'action.active',
                        pl: '10px',
                    }}
                >{label}</Button>
                <Button
                    size="small"
                    onClick={handleToggle}
                    sx={{
                        backgroundColor: 'action.active'
                    }}
                >
                    <KeyboardArrowDownIcon fontSize="medium" sx={{ color: 'secondary.main' }} />
                </Button>
            </ButtonGroup>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition={true}
                disablePortal={true}
                placement='bottom-start'
                style={{
                    zIndex: 10
                }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper sx={{ width: '100%', zIndex: 9 }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <Stack id="split-button-menu" spacing={0}>
                                    {views?.map((option, index) => (
                                        <Stack key={index} direction="row" sx={{ width: '100%', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                                            <Checkbox
                                                checked={selectedIndex === index}
                                                sx={{
                                                    p: 1,
                                                    color: 'lightgray',
                                                    '.MuiSvgIcon-root': {
                                                        border: '1px solid lightgray',
                                                        borderRadius: '2px'
                                                    }
                                                }}
                                                icon={<CheckIcon fontSize="small" sx={{ color: 'white' }} />}
                                                checkedIcon={<CheckIcon fontSize="small" sx={{ color: 'secondary.main' }} />}
                                                onChange={(event) => handleMenuItemClick(event, index)}
                                            />
                                            <Typography sx={{ fontSize: 11, ml: 1, backgroundColor: 'grey.300', p: '3px', borderRadius: 1 }}>{option.level}</Typography>
                                            <Typography sx={{ fontSize: 11, ml: 1, backgroundColor: 'grey.300', p: '3px', borderRadius: 1 }}>{option.regions.join(',')}</Typography>
                                            <Typography sx={{ fontSize: 11, ml: 1, backgroundColor: 'grey.300', p: '3px', borderRadius: 1 }}>{option.stores.join(',')}</Typography>
                                        </Stack>
                                    ))}

                                </Stack>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Fragment>
    );
}